import { SupplierVoucherWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierVoucherWebService.Configuration
});

export default config;
